module.exports = __webpack_public_path__ + "static/media/ebayicon.7bd80dc2.svg";